import React from 'react'
import { useMemo } from 'sb-hooks'
import cx from 'classnames'

import SimpleSelect from 'components/_new/forms/SimpleSelect/SimpleSelect'

import s from './AgeSelect.scss'
import messages from './messages'


const defaultOptions = [
  '17 or under',
  '18 to 24',
  '25 to 34',
  '35 to 44',
  '45 to 54',
  '55 to 64',
  '65 or over',
]

const AgeSelect = ({ className, field, options = defaultOptions }) => {
  const mappedOptions = useMemo(() => (
    options.map((value) => ({ title: value, value }))
  ), [ options ])

  return (
    <SimpleSelect
      className={cx(s.ageSelect, className)}
      field={field}
      options={mappedOptions}
      placeholder={messages.placeholder}
    />
  )
}


export default AgeSelect
